export enum AmplitudeDocumentSource {
	DOC_EXPLORER = 'Document Explorer',
	FEEDBACK_WIDGET = 'Feedback Widget'
}
